@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.bulk-update-container {
  padding: 15px;
}

.loading-indicator {
  width: 100%;
  height: 300px;
}

.available-bulk-actions {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.available-bulk-action {
  padding: 5px 0;

  &:not(:last-child) {
    &:after {
      content: '';
      border-right: 2px solid @orders-drawer--section--border-color;
      padding-left: 10px;
      margin-right: 10px;
      height: 100%;
    }
  }
}

.bulk-action-row {
  display: flex;
  margin-bottom: 10px;
}

.bulk-action-editor {
  width: 100%;
}

.remove-bulk-action-button {
  min-width: 40px;
  margin-left: 10px;
  height: 40px;
  cursor: pointer;

  > svg {
    position: relative;
    fill: @orders-drawer--bulk-update--fill-color;
    padding: 9px;
  }

  &:hover {
    > svg {
      fill: @orders-drawer--bulk-update--hover--fill-color;
    }
  }
}

.section-footer {
  display: flex;
  flex-direction: row-reverse;
  padding-top: 10px;
  border-top: 1px solid @orders-drawer--section--border-color;
}

.bulk-update-shipping-strategies-warning {
  margin-bottom: @space-16;
}
